import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
// Redux
import { useSelector } from "react-redux";
// Functions
import { isPhraseProjectHospital, isNestProjectHospital } from "../../config/projectFunctions";
// Components
import { ActionsManagementContainer, ManagementDiv, AlignContainer } from "./styles";
import ButtonWithIcon from "../buttonWithIcon";
// Assets
import PrescriptionsImg from "../../assets/icons/ico_prescriptions.svg";
import CommitmentQuestionsImg from "../../assets/icons/ico_commitment_questions.svg";
import DiagnosisImg from "../../assets/icons/ico_diagnostics.svg";
import MessagesImg from "../../assets/icons/ico_messages.svg";

const SoftwareMenu = ({ prescriptionsPath, diagnosisPrescriptionsPath, questionnairePath, messagesPath }) => {
  const [isPHRASEOrNESTHospital, setIsPHRASEOrNESTHospital] = useState(false);
  const hospitalName = useSelector(({ clinician }) => clinician.data.HOSPITAL_NAME);
  const [t] = useTranslation("global");

  useEffect(() => {
    const checkHospital = async () => {
      const isPHRASE = await isPhraseProjectHospital(hospitalName);
      const isNEST = await isNestProjectHospital(hospitalName);
      setIsPHRASEOrNESTHospital(isPHRASE || isNEST);
    };
    checkHospital();

    return () => {
      setIsPHRASEOrNESTHospital(false);
    };
  }, [hospitalName]);

  return (
    <ActionsManagementContainer>
      <ManagementDiv>
        <AlignContainer>
          <ButtonWithIcon
            icon={PrescriptionsImg}
            name={t("softwareMenu_prescriptionsAndReports")}
            path={prescriptionsPath}
            margin="0 5px 0 0"
            margin610="0"
            width610="250px"
          />
          {isPHRASEOrNESTHospital && (
            <ButtonWithIcon
              icon={DiagnosisImg}
              name={t("softwareMenu_diagnosis")}
              path={diagnosisPrescriptionsPath}
              margin="0 5px 0 0"
              margin610="0"
              width610="250px"
            />
          )}
          <ButtonWithIcon
            icon={CommitmentQuestionsImg}
            name={t("softwareMenu_questionnaire")}
            path={questionnairePath}
            margin="0 5px 0 0"
            margin610="0"
            width610="250px"
          />
          <ButtonWithIcon icon={MessagesImg} name={t("softwareMenu_messages")} path={messagesPath} width610="250px" />
        </AlignContainer>
      </ManagementDiv>
    </ActionsManagementContainer>
  );
};

export default SoftwareMenu;
